import { IOperationResultNoValue } from '@ViewModels';
import { IModalProps } from '@WebComponents/Modal';
import { TextInputModal } from '@WebComponents/TextInputModal';
import * as React from 'react';
import { useEventLogging } from '../../../../models/Logging';
import { useErrorMessages } from '../../../../models/hooks/appStateHooks';
import { useDuplicateIndustryAutomationTemplateMutation } from '../../../../queries/Admin/AutomationTemplate';
import { IndustryAutomationTemplateData } from '../../../../queries/Admin/AutomationTemplate/useIndustryAutomationTemplatesData';
import { Button } from '../../../../web/components/Button';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';

interface IProps {
	industryAutomationTemplate?: IndustryAutomationTemplateData;
	isOpen: boolean;
	onRequestClose(
		createdAutomationTemplate?: IndustryAutomationTemplateData,
		cancel?: boolean,
		error?: IOperationResultNoValue
	): void;
}

export const DuplicateSystemAutomationTemplateModal: React.FC<IProps> = props => {
	const errorMessages = useErrorMessages();
	const { logEvent, logApiError } = useEventLogging('DuplicateAutomationTemplateModal');

	const { industryAutomationTemplate, onRequestClose, isOpen } = props;

	const duplicateMutation = useDuplicateIndustryAutomationTemplateMutation();

	const onModalRequestClose = React.useCallback(
		async (name?: string, cancel?: boolean) => {
			const trimmedName = !cancel ? (name || '').trim() : null;

			let createdTemplate: IndustryAutomationTemplateData = null;

			let err: IOperationResultNoValue = null;
			if (trimmedName) {
				logEvent('DuplicateAutomation', {
					id: industryAutomationTemplate.id,

					nameLength: name.length,
				});
				try {
					const result = await duplicateMutation.mutateAsync({
						templateId: industryAutomationTemplate.id,
						name,
					});

					createdTemplate = {
						id: result.template.id,
						name: result.template.name,
						template: result.template,
						industries: Object.keys(result.industries) as any[],
						status: result.industries[Object.keys(result.industries)[0]] as any,
						systemTemplate: result,
						creationDate: result.template.creationDate,
					};
				} catch (error) {
					logApiError('DuplicateAutomationTemplate-Error', error);

					errorMessages.pushApiError(error);

					err = error;
				}
			}
			onRequestClose?.(createdTemplate, cancel, err);
		},
		[industryAutomationTemplate, onRequestClose, logEvent, logApiError, errorMessages, duplicateMutation]
	);

	const modalProps: IModalProps<string> = {
		isOpen,
		onRequestClose: onModalRequestClose,
	};

	const onRenderCta = (buttonProps?: { onClick: (e: React.MouseEvent<HTMLElement>) => void }) => {
		return <Button onClick={buttonProps?.onClick} label='Duplicate' disabled={duplicateMutation.isPending} />;
	};
	return (
		<TextInputModal
			cta={onRenderCta}
			modalProps={modalProps}
			placeholderText='New Automation name'
			title={`Duplicate Automation: "${industryAutomationTemplate?.name || ''}"`}
		>
			{duplicateMutation.isPending && <LoadingSpinner type='small' />}
		</TextInputModal>
	);
};
